module.exports = __webpack_public_path__ + "media/images/microsoft-29e91a80263275321949f23d125e024a.svg";